import {
  Form,
  FormInstance,
  Row,
  Col,
  Input,
  DatePicker,
  Divider,
  Skeleton,
} from 'antd'
import { useRef, forwardRef, useImperativeHandle, useCallback } from 'react'
import Uploadfiles, { fileFile } from '@/modules/goodsdetailmodules/uploadfiles'
import ReadOnlyFormItem from '@/components/ReadOnlyFormItem'
import ContactSelector from '@/components/ContactSelector'
import { ContactPageData } from '@/api/contact'

import XJForm, { XJFormRef } from '../XJForm'
import { InquiryQuotationListItem } from '../../reducer'
import { FormFields } from '../AttachmentPreview/utils'
import { supplierInquiryStatusEnum } from '@/global/enum'
import { AttachmentPreview } from '../AttachmentPreview'
import { XJ_UPLOAD_OPTION } from '@/global/config'

export interface BJDFormProps {
  form: FormInstance<FormFields>
  item?: InquiryQuotationListItem
  isLoading?: boolean
  groupCode?: string
}

export interface BJDFormRef {
  getXJFormRef: () => React.RefObject<XJFormRef>
}
const defaultItem: any = {
  items: [],
}
const BJDForm = forwardRef<BJDFormRef, BJDFormProps>((props, ref) => {
  const { form, item = defaultItem, isLoading, groupCode } = props
  const xjFormRef = useRef<XJFormRef>(null)

  useImperativeHandle(ref, () => ({
    getXJFormRef: () => xjFormRef,
  }))

  const onlyShowContent = supplierInquiryStatusEnum.isValueInLabels(
    item.inquiryStatus,
    ['已报价', '采购方取消'],
  )

  // 处理联系人选择
  const handleContactChange = useCallback(
    (contactId: string, contact?: ContactPageData) => {
      if (contact) {
        // 从下拉列表选择联系人时，自动填充联系人相关信息
        form.setFieldsValue({
          contactPerson: contact.name,
          contactPhone: contact.phone,
          contactEmail: contact.mail,
          supplierAddress: contact.contactAddress,
        })
      } else if (contactId) {
        // 手动输入联系人姓名时，只设置联系人姓名，其他字段保持不变
        form.setFieldsValue({
          contactPerson: contactId,
        })
      } else {
        // 清空时，清空联系人相关信息
        form.setFieldsValue({
          contactPerson: '',
          contactPhone: '',
          contactEmail: '',
          supplierAddress: '',
        })
      }
    },
    [form],
  )

  return (
    <Form form={form} labelAlign="right">
      <div className="text-[16px] font-bold mt-[20px]">供应商信息</div>
      <Divider className="my-[15px]"></Divider>
      <Skeleton loading={isLoading}>
        <Row gutter={24}>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'供应商名称'}
              name="supplierName"
              readOnly={onlyShowContent}
              // rules={[{ required: true, message: '请输入供应商名称' }]}
            >
              <Input placeholder="请输入" allowClear disabled />
            </ReadOnlyFormItem>
          </Col>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'供应商联系人'}
              name="contactPerson"
              readOnly={onlyShowContent}
              rules={[{ required: true, message: '请输入供应商联系人' }]}
            >
              {!onlyShowContent ? (
                <ContactSelector
                  placeholder="请选择联系人"
                  onChange={handleContactChange}
                  allowClear
                  groupCode={groupCode}
                  allowInput
                />
              ) : (
                <Input placeholder="请输入" allowClear />
              )}
            </ReadOnlyFormItem>
          </Col>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'联系电话'}
              name="contactPhone"
              readOnly={onlyShowContent}
              rules={[{ required: true, message: '请输入联系电话' }]}
            >
              <Input placeholder="请输入" allowClear />
            </ReadOnlyFormItem>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'邮箱'}
              name="contactEmail"
              readOnly={onlyShowContent}
              rules={[{ type: 'email', message: '请输入正确的邮箱' }]}
            >
              <Input placeholder="请输入" allowClear />
            </ReadOnlyFormItem>
          </Col>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'地址'}
              name="supplierAddress"
              readOnly={onlyShowContent}
            >
              <Input placeholder="请输入" allowClear />
            </ReadOnlyFormItem>
          </Col>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'报价有效期'}
              name="validUntil"
              readOnly={onlyShowContent}
              rules={[{ required: true, message: '请选择报价有效期' }]}
              formatValue={(value) => value?.format('YYYY-MM-DD')}
            >
              <DatePicker
                style={{ width: '100%' }}
                format="YYYY-MM-DD"
                getPopupContainer={() => document.body}
              />
            </ReadOnlyFormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {/* 作为 antd Form 自定义控件使用：用 dataSource 作为值，onDataSourceChange 作为触发事件 */}
            {!onlyShowContent && (
              <Form.Item
                label="批量项目附件"
                name="attachmentList"
                valuePropName="dataSource"
                trigger="onChange"
                initialValue={[]}
              >
                <Uploadfiles
                  textBtn="选择文件"
                  type="inquiry"
                  {...XJ_UPLOAD_OPTION}
                  uploadBtnSuffix={
                    <span className="text-[#999] ml-[10px]">
                      支持常见的图片、文件、压缩包
                    </span>
                  }
                />
              </Form.Item>
            )}
            {onlyShowContent && (
              <Form.Item
                label="批量项目附件"
                name="attachment"
                valuePropName="attachment"
                trigger="onChange"
                initialValue={[]}
              >
                <AttachmentPreview></AttachmentPreview>
              </Form.Item>
            )}
          </Col>
        </Row>
      </Skeleton>
      <div className="text-[16px] font-bold">询价清单</div>
      <Divider className="my-[15px]"></Divider>

      {/* <Skeleton loading={isLoading}>
        <XJForm ref={xjFormRef} item={item!} />
      </Skeleton> */}
    </Form>
  )
})

BJDForm.displayName = 'BJDForm'

export default BJDForm
import {
  Form,
  FormInstance,
  Row,
  Col,
  Input,
  DatePicker,
  Divider,
  Skeleton,
} from 'antd'
import { useRef, forwardRef, useImperativeHandle, useCallback } from 'react'
import Uploadfiles, { fileFile } from '@/modules/goodsdetailmodules/uploadfiles'
import ReadOnlyFormItem from '@/components/ReadOnlyFormItem'
import ContactSelector from '@/components/ContactSelector'
import { ContactPageData } from '@/api/contact'

import XJForm, { XJFormRef } from '../XJForm'
import { InquiryQuotationListItem } from '../../reducer'
import { FormFields } from '../AttachmentPreview/utils'
import { supplierInquiryStatusEnum } from '@/global/enum'
import { AttachmentPreview } from '../AttachmentPreview'
import { XJ_UPLOAD_OPTION } from '@/global/config'

export interface BJDFormProps {
  form: FormInstance<FormFields>
  item?: InquiryQuotationListItem
  isLoading?: boolean
  groupCode?: string
}

export interface BJDFormRef {
  getXJFormRef: () => React.RefObject<XJFormRef>
}
const defaultItem: any = {
  items: [],
}
const BJDForm = forwardRef<BJDFormRef, BJDFormProps>((props, ref) => {
  const { form, item = defaultItem, isLoading, groupCode } = props
  const xjFormRef = useRef<XJFormRef>(null)

  useImperativeHandle(ref, () => ({
    getXJFormRef: () => xjFormRef,
  }))

  const onlyShowContent = supplierInquiryStatusEnum.isValueInLabels(
    item.inquiryStatus,
    ['已报价', '采购方取消'],
  )

  // 处理联系人选择
  const handleContactChange = useCallback(
    (contactId: string, contact?: ContactPageData) => {
      if (contact) {
        // 从下拉列表选择联系人时，自动填充联系人相关信息
        form.setFieldsValue({
          contactPerson: contact.name,
          contactPhone: contact.phone,
          contactEmail: contact.mail,
          supplierAddress: contact.contactAddress,
        })
      } else if (contactId) {
        // 手动输入联系人姓名时，只设置联系人姓名，其他字段保持不变
        form.setFieldsValue({
          contactPerson: contactId,
        })
      } else {
        // 清空时，清空联系人相关信息
        form.setFieldsValue({
          contactPerson: '',
          contactPhone: '',
          contactEmail: '',
          supplierAddress: '',
        })
      }
    },
    [form],
  )

  return (
    <Form form={form} labelAlign="right">
      <div className="text-[16px] font-bold mt-[20px]">供应商信息</div>
      <Divider className="my-[15px]"></Divider>
      <Skeleton loading={isLoading}>
        <Row gutter={24}>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'供应商名称'}
              name="supplierName"
              readOnly={onlyShowContent}
              // rules={[{ required: true, message: '请输入供应商名称' }]}
            >
              <Input placeholder="请输入" allowClear disabled />
            </ReadOnlyFormItem>
          </Col>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'供应商联系人'}
              name="contactPerson"
              readOnly={onlyShowContent}
              rules={[{ required: true, message: '请输入供应商联系人' }]}
            >
              {!onlyShowContent ? (
                <ContactSelector
                  placeholder="请选择联系人"
                  onChange={handleContactChange}
                  allowClear
                  groupCode={groupCode}
                  allowInput
                />
              ) : (
                <Input placeholder="请输入" allowClear />
              )}
            </ReadOnlyFormItem>
          </Col>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'联系电话'}
              name="contactPhone"
              readOnly={onlyShowContent}
              rules={[{ required: true, message: '请输入联系电话' }]}
            >
              <Input placeholder="请输入" allowClear />
            </ReadOnlyFormItem>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'邮箱'}
              name="contactEmail"
              readOnly={onlyShowContent}
              rules={[{ type: 'email', message: '请输入正确的邮箱' }]}
            >
              <Input placeholder="请输入" allowClear />
            </ReadOnlyFormItem>
          </Col>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'地址'}
              name="supplierAddress"
              readOnly={onlyShowContent}
            >
              <Input placeholder="请输入" allowClear />
            </ReadOnlyFormItem>
          </Col>
          <Col span={8}>
            <ReadOnlyFormItem
              label={'报价有效期'}
              name="validUntil"
              readOnly={onlyShowContent}
              rules={[{ required: true, message: '请选择报价有效期' }]}
              formatValue={(value) => value?.format('YYYY-MM-DD')}
            >
              <DatePicker
                style={{ width: '100%' }}
                format="YYYY-MM-DD"
                getPopupContainer={() => document.body}
              />
            </ReadOnlyFormItem>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            {/* 作为 antd Form 自定义控件使用：用 dataSource 作为值，onDataSourceChange 作为触发事件 */}
            {!onlyShowContent && (
              <Form.Item
                label="批量项目附件"
                name="attachmentList"
                valuePropName="dataSource"
                trigger="onChange"
                initialValue={[]}
              >
                <Uploadfiles
                  textBtn="选择文件"
                  type="inquiry"
                  {...XJ_UPLOAD_OPTION}
                  uploadBtnSuffix={
                    <span className="text-[#999] ml-[10px]">
                      支持常见的图片、文件、压缩包
                    </span>
                  }
                />
              </Form.Item>
            )}
            {onlyShowContent && (
              <Form.Item
                label="批量项目附件"
                name="attachment"
                valuePropName="attachment"
                trigger="onChange"
                initialValue={[]}
              >
                <AttachmentPreview></AttachmentPreview>
              </Form.Item>
            )}
          </Col>
        </Row>
      </Skeleton>
      <div className="text-[16px] font-bold">询价清单</div>
      <Divider className="my-[15px]"></Divider>

      {/* <Skeleton loading={isLoading}>
        <XJForm ref={xjFormRef} item={item!} />
      </Skeleton> */}
    </Form>
  )
})

BJDForm.displayName = 'BJDForm'

export default BJDForm
